module.exports = __webpack_public_path__ + "media/images/icon_member01_20-19-8e62214448d12deda3ef382118c612df.png";